export function PlusCircleSvg(
  props: Pick<React.SVGProps<SVGSVGElement>, "width" | "height" | "viewBox">,
) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1395_8)">
        <path
          d="M15 3.75C8.7868 3.75 3.75 8.7868 3.75 15C3.75 21.2132 8.7868 26.25 15 26.25C21.2132 26.25 26.25 21.2132 26.25 15C26.25 12.1187 25.1668 9.49034 23.3854 7.5M23.3854 7.5L22.9688 11.7188M23.3854 7.5L27.6562 9.84375"
          stroke="#0DBD27"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M10.3125 15H19.6875"
          stroke="#0DBD27"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 10.3125V19.6875"
          stroke="#0DBD27"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1395_8">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
